// This file is part of MinIO Console Server
// Copyright (c) 2021 MinIO, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU Affero General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU Affero General Public License for more details.
//
// You should have received a copy of the GNU Affero General Public License
// along with this program.  If not, see <http://www.gnu.org/licenses/>.

import * as React from "react";
import { SVGProps } from "react";

const AccountIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      {...props}
      className={`min-icon`}
      fill={"currentcolor"}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 256 256"
    >
      <defs>
        <clipPath id="prefix__a">
          <path d="M0 0h256v256H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <g transform="translate(4343.797 1174.239)">
          <path
            data-name="Trazado 391"
            d="M-4243.896-1049.602c26.662 0 48.334-22.564 48.334-50.314s-21.672-50.318-48.334-50.318c-26.633 0-48.32 22.571-48.32 50.318s21.687 50.314 48.32 50.314zm0-84.9c18.283 0 33.168 15.521 33.168 34.59s-14.885 34.587-33.168 34.587-33.133-15.518-33.133-34.587 14.863-34.598 33.133-34.598z"
          />
          <path
            data-name="Trazado 391 - Contorno"
            d="M-4243.896-1049.502c-26.7 0-48.42-22.616-48.42-50.414s21.721-50.418 48.42-50.418 48.434 22.618 48.434 50.418-21.728 50.414-48.434 50.414zm0-100.633c-26.589 0-48.22 22.528-48.22 50.218s21.631 50.214 48.22 50.214 48.234-22.526 48.234-50.214-21.642-50.222-48.234-50.222zm0 84.905c-18.325 0-33.233-15.56-33.233-34.687s14.908-34.69 33.233-34.69c18.344 0 33.268 15.562 33.268 34.69s-14.924 34.684-33.268 34.684zm0-69.177c-18.214 0-33.033 15.472-33.033 34.49s14.818 34.487 33.033 34.487c18.234 0 33.068-15.471 33.068-34.487s-14.834-34.493-33.068-34.493z"
          />
          <path
            data-name="Trazado 392"
            d="M-4304.551-986.731a21.435 21.435 0 0019.545 12.09h77.879a21.139 21.139 0 0019.518-12.263 26.16 26.16 0 00-2.566-26.32 70.472 70.472 0 00-26.475-21.938 68 68 0 00-33.158-6.836 69.928 69.928 0 00-51.76 28.227c-.408.544-.779 1.1-1.162 1.656a25.64 25.64 0 00-1.821 25.384zm103.941-6.824a6.644 6.644 0 01-6.518 3.9h-77.879a7.062 7.062 0 01-6.662-3.962 9.972 9.972 0 01.816-9.871v-.011c.264-.417.574-.836.879-1.25a55.189 55.189 0 0140.912-22.239c.871-.052 1.752-.07 2.625-.07a56.234 56.234 0 0144.684 22.885 10.7 10.7 0 011.143 10.618z"
          />
          <path
            data-name="Trazado 392 - Contorno"
            d="M-4207.127-974.541h-77.879a21.532 21.532 0 01-19.634-12.145 25.743 25.743 0 011.827-25.485c.1-.149.205-.3.307-.445.274-.4.559-.815.858-1.215a70.024 70.024 0 0151.834-28.266 63.11 63.11 0 013.514-.1 66.24 66.24 0 0115.073 1.766 71.123 71.123 0 0114.621 5.178 70.591 70.591 0 0126.512 21.97 26.265 26.265 0 012.576 26.422 21.26 21.26 0 01-19.609 12.32zm-39.173-67.456c-1.167 0-2.346.033-3.5.1a69.821 69.821 0 00-51.685 28.185c-.3.4-.581.81-.854 1.209-.1.149-.2.3-.307.445a25.54 25.54 0 00-1.813 25.283 21.337 21.337 0 0019.456 12.034h77.879a21.064 21.064 0 0019.427-12.206 26.062 26.062 0 00-2.557-26.218 70.383 70.383 0 00-26.437-21.907 70.932 70.932 0 00-14.579-5.163 66.044 66.044 0 00-15.031-1.763zm39.173 52.437h-77.879a7.486 7.486 0 01-4.64-1.447 7.372 7.372 0 01-2.112-2.569 10.072 10.072 0 01.806-9.947v-.009l.016-.025c.253-.4.551-.805.84-1.2l.043-.058a55.311 55.311 0 0140.987-22.28c.8-.047 1.658-.07 2.63-.07a56.34 56.34 0 0144.765 22.926 10.8 10.8 0 011.152 10.725 6.738 6.738 0 01-6.608 3.954zm-83.625-13.915v.012l-.018.026a9.868 9.868 0 00-.809 9.77 7.162 7.162 0 002.054 2.5 7.29 7.29 0 004.519 1.407h77.879a6.551 6.551 0 006.427-3.839 10.594 10.594 0 00-1.133-10.521 56.137 56.137 0 00-44.6-22.844c-.968 0-1.825.023-2.619.07a55.108 55.108 0 00-40.837 22.2l-.043.059c-.284.38-.574.774-.82 1.161z"
          />
          <path
            data-name="Trazado 393"
            d="M-4118.988-1128.356h-54.7a7.428 7.428 0 00-7.434 7.431 7.432 7.432 0 007.434 7.427h54.7a16.332 16.332 0 0116.313 16.32v124.74a16.331 16.331 0 01-16.312 16.32h-193.631a16.342 16.342 0 01-16.324-16.32v-124.74a16.343 16.343 0 0116.324-16.32 7.443 7.443 0 007.426-7.427 7.439 7.439 0 00-7.426-7.431 31.207 31.207 0 00-31.178 31.178v124.74a31.211 31.211 0 0031.178 31.181h193.631a31.218 31.218 0 0031.191-31.181v-124.74a31.214 31.214 0 00-31.192-31.178z"
          />
          <path
            data-name="Trazado 393 - Contorno"
            d="M-4312.619-1128.456a7.537 7.537 0 017.526 7.531 7.535 7.535 0 01-7.526 7.527 16.24 16.24 0 00-16.224 16.22v124.74a16.24 16.24 0 0016.224 16.22h193.631a16.235 16.235 0 0016.212-16.22v-124.74a16.235 16.235 0 00-16.212-16.22h-54.7a7.539 7.539 0 01-7.534-7.527 7.48 7.48 0 012.2-5.325 7.485 7.485 0 015.329-2.205h54.7a31.32 31.32 0 0131.292 31.278v124.74a31.322 31.322 0 01-31.292 31.281h-193.631a31.315 31.315 0 01-31.278-31.281v-124.74a31.313 31.313 0 0131.283-31.279zm193.631 172.438h-193.631a16.441 16.441 0 01-16.424-16.42v-124.74a16.441 16.441 0 0116.424-16.42 7.334 7.334 0 007.326-7.327 7.336 7.336 0 00-7.326-7.331 31.113 31.113 0 00-31.078 31.078v124.74a31.114 31.114 0 0031.078 31.081h193.631a31.121 31.121 0 0031.091-31.081v-124.74a31.12 31.12 0 00-31.091-31.078h-54.7a7.288 7.288 0 00-5.188 2.147 7.282 7.282 0 00-2.146 5.184 7.338 7.338 0 007.333 7.327h54.7a16.435 16.435 0 0116.413 16.42v124.74a16.435 16.435 0 01-16.412 16.42z"
          />
          <rect
            data-name="Rect\xE1ngulo 809"
            width={50.961}
            height={43.41}
            rx={1.024}
            transform="translate(-4172.15 -1093.01)"
          />
          <path
            data-name="Rect\xE1ngulo 809 - Contorno"
            d="M-4171.126-1093.11h48.913a1.125 1.125 0 011.124 1.124v41.363a1.125 1.125 0 01-1.124 1.124h-48.913a1.125 1.125 0 01-1.124-1.124v-41.363a1.125 1.125 0 011.124-1.124zm48.913 43.41a.925.925 0 00.924-.924v-41.362a.925.925 0 00-.924-.924h-48.913a.925.925 0 00-.924.924v41.363a.925.925 0 00.924.924z"
          />
          <rect
            data-name="Rect\xE1ngulo 810"
            width={50.961}
            height={20.864}
            rx={1.615}
            transform="translate(-4172.15 -1031.303)"
          />
          <path
            data-name="Rect\xE1ngulo 810 - Contorno"
            d="M-4170.535-1031.403h47.731a1.717 1.717 0 011.715 1.715v17.634a1.717 1.717 0 01-1.715 1.715h-47.731a1.717 1.717 0 01-1.715-1.715v-17.634a1.717 1.717 0 011.715-1.715zm47.731 20.864a1.516 1.516 0 001.515-1.515v-17.634a1.516 1.516 0 00-1.515-1.515h-47.731a1.516 1.516 0 00-1.515 1.515v17.634a1.516 1.516 0 001.515 1.515z"
          />
          <rect
            data-name="Rect\xE1ngulo 811"
            width={50.961}
            height={20.864}
            rx={1.615}
            transform="translate(-4172.15 -995.506)"
          />
          <path
            data-name="Rect\xE1ngulo 811 - Contorno"
            d="M-4170.535-995.606h47.731a1.717 1.717 0 011.715 1.715v17.634a1.717 1.717 0 01-1.715 1.715h-47.731a1.717 1.717 0 01-1.715-1.715v-17.634a1.717 1.717 0 011.715-1.715zm47.731 20.864a1.516 1.516 0 001.515-1.515v-17.634a1.516 1.516 0 00-1.515-1.515h-47.731a1.516 1.516 0 00-1.515 1.515v17.634a1.516 1.516 0 001.515 1.515z"
          />
        </g>
      </g>
    </svg>
  );
};

export default AccountIcon;
